<script>
// const olapUrl = `${window.document.location.protocol}${window.document.location.hostname}/18721`;
const olapUrl = `${window.document.location.protocol}${window.document.location.origin.split(':')[1]}/18721`;
export default
{
  olapUrl
};
</script>
